module.exports = __webpack_public_path__ + "img/6.67be3e2a.jpg";